import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const [headerClass, setHeaderClass] = useState('');
  const [activeSection, setActiveSection] = useState('home');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  const location = useLocation();
  const navigate = useNavigate();

  // Handle scroll effects and update active section
  useEffect(() => {
    const handleScroll = () => {
      // Update header appearance on scroll
      if (window.scrollY > 50) {
        setHeaderClass('sticked');
      } else {
        setHeaderClass('');
      }

      // Update active section based on scroll position
      const sections = ['home', 'about', 'services', 'contact'];
      const currentPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (currentPosition >= offsetTop && currentPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Handle scrolling to the correct section when the page loads with a hash
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      setActiveSection(sectionId);

      // Wait for page to fully load before scrolling
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          window.scrollTo({
            top: element.offsetTop - 80,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [location.hash]);

  // Navigate to section - always using URL approach
  const navigateToSection = (sectionId) => {
    navigate(`/home#${sectionId}`);
  };

  return (
    <header id="header" className={`header fixed-top ${headerClass}`}>
      <Container className="container-xl d-flex align-items-center justify-content-between">
        <Navbar.Brand
          onClick={() => navigateToSection('home')}
          className="logo d-flex align-items-center"
          style={{ cursor: 'pointer' }}
        >
          <img
              src="/images/accurati-logo-v3.png"
              alt="AccuraTI Logo"
              className="logo-image"
          />
          <span>&nbsp;</span>
        </Navbar.Brand>

        {/* Desktop Navigation - hidden on mobile */}
        <Nav className="desktop-nav d-none d-lg-flex">
          <Nav.Item>
            <Nav.Link
              onClick={() => navigateToSection('home')}
              className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
            >
              Home
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              onClick={() => navigateToSection('about')}
              className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}
            >
              About
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
                onClick={() => navigateToSection('services')}
                className={`nav-link ${activeSection === 'services' ? 'active' : ''}`}
            >
              Services
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              onClick={() => navigate('/product-development')}
              className={`nav-link ${location.pathname === '/product-development' ? 'active' : ''}`}
            >
              Prototyping
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              onClick={() => navigateToSection('contact')}
              className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}
            >
              Contact
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {/* Mobile Menu Toggle */}
        {isMobile && (
          <button
            className="mobile-nav-toggle"
            onClick={() => navigateToSection('contact')}
            aria-label="Contact Us"
          >
            <span className="direct-contact-btn">Contact</span>
          </button>
        )}
      </Container>
    </header>
  );
};

export default Navigation;
